/**
 * @file paddlehub demo 新冠肺炎医疗影像入口
 * @author FengGuang(fengguang01@baidu.com)
 */

import MedicalImage from './MedicalImage';
import './style.less';

export default MedicalImage;
